export default __webpack_public_path__ + "static/media/icono-control-tiempo.3b2b9ea5.png";